import { IANAZone } from "luxon";

import { ISlotUpdateEvent } from "../Components/BookingWizard/BookingWizard";
import { Calendar, EnhancedCalendar } from "../Models/Calendar";
import { Customer } from "../Models/Customer";
import { EnhancedOpsCalendar, OpsCalendar } from "../Models/OpsCalendar";

/** Utility class for mapping Ops objects to enhanced objects and checking supported centers */
class OpsMappingUtility {
  /**
   * Converts the calendar to an enhanced calendar using center time zone
   * @param calendar - The calendar to convert
   * @param centerTimeZone - The center time zone
   * @param centerId - The center id to check if supported
   */
  public static toBookingCalendar = (
    calendar: OpsCalendar | Calendar,
    centerTimeZone: IANAZone,
    slotUpdateEvent?: ISlotUpdateEvent
  ): EnhancedOpsCalendar | EnhancedCalendar =>
    new EnhancedOpsCalendar(calendar as OpsCalendar, centerTimeZone, slotUpdateEvent);

  /**
   * Checks if the customer has enough information provided for the calendar call event.
   * Center id is taken care of in the handleCalendarValidity function
   * but also added here for completeness.
   * @param customer The customer object to check.
   */
  public static isCustomerValidForBooking = (
    customer: Pick<
      Customer,
      | "id"
      | "firstName"
      | "dateOfBirth"
      | "lastName"
      | "phoneNumber"
      | "distanceToCenter"
      | "weight"
      | "height"
      | "zipCode"
      | "centerId"
    >
  ): boolean => {
    return (
      !!customer?.id &&
      !!customer?.firstName &&
      !!customer?.dateOfBirth &&
      !!customer?.lastName &&
      !!customer?.phoneNumber &&
      !!customer?.distanceToCenter &&
      !!customer?.weight &&
      !!customer?.height &&
      !!customer?.height?.feet &&
      !!customer?.zipCode &&
      !!customer?.centerId
    );
  };
}

export default OpsMappingUtility;
